import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export function collectInvalidPaths(control: AbstractControl, path = ''): string[] {
  if (control.valid) return [];

  const children: [string, AbstractControl][] =
    control instanceof FormGroup
      ? Object.entries(control.controls)
      : control instanceof FormArray
        ? control.controls.map((child, index): [string, AbstractControl] => [String(index), child])
        : [];

  const invalidChildren = children.flatMap(([key, child]) => collectInvalidPaths(child, path ? `${path}.${key}` : key));
  return invalidChildren.length ? invalidChildren : [path];
}
